// @flow

import React, { Fragment } from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { UserInfoConsumer } from '../../contexts/UserInfo';
import Provider, { CommonFiltersConsumer } from './provider';

import Margin from '../../components/Margin';

import ProAccountRequired from '../../buisness/ProAccountRequired';

import Filters from './components/Filters';
import Filter from './components/Filter';

import DayPicker from './filters/DayPicker/container';
import CountryFilter from './filters/Country';
import PlatformFilter from './filters/Platform';

type Props = {
  fromDate: Date,
  toDate: Date,
  minDate: Date,
  maxDate: Date,
  country?: string,
  platform?: string,
  countryPicker?: boolean,
  platformPicker?: boolean,
  isAllowBasic?: boolean,
  maxPeriod?: number,
  datePresets?: Array<{
    periodDays: number,
    fromDate: Date,
    toDate: Date,
  }>,
};

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 20px;
  margin-right: 10px;

  ${breakpoint('tablet')`
    flex-flow: row;
  `};
`;

const CommonFilters = (props: Props) => (
  <UserInfoConsumer>
    {({ userInfo }) => {
      const proSubscriptionIsActive =
        !!userInfo &&
        (userInfo.subscription.isActive ||
          userInfo.isChildSubscription); /* &&
        userInfo.subscription.activatedPlan === process.env.REACT_APP_PLAN_PRO; */

      const basicSubscriptionIsActive = true;
      /* !!userInfo &&
        userInfo.subscription.isActive &&
        userInfo.subscription.activatedPlan ===
          process.env.REACT_APP_PLAN_BASIC; */

      const isFilterAllow = props.isAllowBasic && basicSubscriptionIsActive;

      return (
        <Fragment>
          {!proSubscriptionIsActive && !props.isAllowBasic && (
            <ProAccountRequired filters />
          )}
          <Margin bottom={1} />
          <Wrapper>
            <CommonFiltersConsumer>
              {({
                setPeriodDays,

                setCountry,

                setPlatform,
              }) => (
                <Fragment>
                  <Filters>
                    <Filter>
                      <DayPicker
                        fromDate={props.fromDate}
                        toDate={props.toDate}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        datePresets={
                          props.datePresets ? props.datePresets : null
                        }
                        maxPeriod={props.maxPeriod ? props.maxPeriod : null}
                        onApplyPeriod={(fromDate, toDate) => {
                          setPeriodDays(fromDate, toDate);
                        }}
                        subscriptionIsActive={
                          proSubscriptionIsActive || isFilterAllow
                        }
                      />
                    </Filter>
                    {props.countryPicker ? (
                      <Filter>
                        <CountryFilter
                          selected={props.country}
                          onChange={country => {
                            setCountry(country);
                          }}
                          subscriptionIsActive={
                            proSubscriptionIsActive || isFilterAllow
                          }
                        />
                      </Filter>
                    ) : null}
                    {props.platformPicker ? (
                      <Filter>
                        <PlatformFilter
                          selected={props.platform}
                          onChange={platform => {
                            setPlatform(platform);
                          }}
                          subscriptionIsActive={
                            proSubscriptionIsActive || isFilterAllow
                          }
                        />
                      </Filter>
                    ) : null}
                  </Filters>
                </Fragment>
              )}
            </CommonFiltersConsumer>
          </Wrapper>
        </Fragment>
      );
    }}
  </UserInfoConsumer>
);

export { Provider as CommonFiltersProvider, CommonFiltersConsumer };

export default CommonFilters;



// WEBPACK FOOTER //
// ./src/buisness/CommonFilters/index.js